import { Navigate } from '@sorare/routing';
import { FOOTBALL_PL } from '@sorare/core/src/constants/__generated__/routes';

const EPLPage = () => {
  return <Navigate to={FOOTBALL_PL} />;
};
export default EPLPage;
